import { splitAccountKey } from '@sales-portal/domain/pricing/blocs/utils/account-key';

export interface PricingHubBookmarkCounts {
  bookmarkCount: number;
  restaurantCount: number;
  variantPackCount: number;
}

// Counts the bookmarks store's keys — one per bookmarked (variant pack,
// restaurant) pair, so the key count *is* the bookmark count and the tile
// always agrees with the sidebar badge counting the same keys.
export const toPricingHubBookmarkCounts = (
  keys: string[],
): PricingHubBookmarkCounts => {
  const variantPackUUIDs = new Set<string>();
  const restaurantUUIDs = new Set<string>();

  keys.forEach((key) => {
    const { restaurantUUID, variantPackUUID } = splitAccountKey(key);
    if (variantPackUUID) {
      variantPackUUIDs.add(variantPackUUID);
    }
    if (restaurantUUID) {
      restaurantUUIDs.add(restaurantUUID);
    }
  });

  return {
    bookmarkCount: keys.length,
    restaurantCount: restaurantUUIDs.size,
    variantPackCount: variantPackUUIDs.size,
  };
};
